import { Done } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import InputField from '../../elements/InputField';

const ReviewForm = ({ onSubmit, review, isEditable }) => {
  return (
    <Formik
      initialValues={{
        review: review.updated_review || '',
        userId: review.user.id,
      }}
      onSubmit={onSubmit}>
      {({ handleSubmit, values }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <Stack direction="row" alignItems="center" spacing={1}>
            {isEditable ? (
              <InputField
                id="review"
                type="text"
                value={values.review}
                name="review"
                readOnly={!isEditable}
                fullWidth
                multiline
                sx={{ fontSize: '14px' }}
                endAdornment={
                  isEditable && (
                    <IconButton
                      title="Save"
                      type="submit"
                      color="success"
                      sx={{ padding: 0 }}>
                      <Done />
                    </IconButton>
                  )
                }
              />
            ) : (
              <Typography sx={{ fontSize: '14px', textAlign: 'center' }}>{values.review}</Typography>
            )}
          </Stack>
        </Form>
      )}
    </Formik>
  );
};

export default ReviewForm;
